import { useState } from "react";
import axios from "axios";
import { CheckCircle2, Loader2, Send } from "lucide-react";
import { API } from "@/lib/api";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/newsletter`, { email });
      setDone(true);
    } catch {
      setError("Inscription impossible pour le moment — réessayez.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <p data-testid="newsletter-success" className="flex items-center gap-2 text-sm font-medium text-cream">
        <CheckCircle2 size={18} strokeWidth={1.5} className="text-terracotta" />
        Bienvenue dans le journal gourmand — premier rendez-vous le mois prochain.
      </p>
    );
  }

  return (
    <form onSubmit={submit} className="w-full max-w-md" data-testid="newsletter-form">
      <div className="flex gap-2">
        <input
          type="email"
          required
          data-testid="newsletter-email-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="votre@email.fr"
          className="w-full rounded-full border border-cream/20 bg-cream/10 px-5 py-3.5 text-sm text-cream placeholder:text-cream/40 focus:border-terracotta focus:outline-none"
        />
        <button
          type="submit"
          data-testid="newsletter-submit-btn"
          disabled={loading}
          className="btn-primary shrink-0 !px-6 !py-3.5 !bg-terracotta hover:!bg-cream hover:!text-espresso"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : <Send size={14} strokeWidth={1.5} />}
          S'inscrire
        </button>
      </div>
      {error && <p className="mt-2 text-xs text-terracotta" data-testid="newsletter-error">{error}</p>}
      <p className="mt-2 text-xs text-cream/40">Un email par mois, désinscription en un clic.</p>
    </form>
  );
}
